/* eslint-disable @next/next/no-img-element */
// Shared Apple Pay / Google Pay presentation for the checkout payment step. Both the
// saved-card dropdown (ChoosePaymentDropdown) and the card-less toggle
// (InlinePaymentSelector) render the wallet the same way — a brand mark + label — so
// the mark/label derivation and the row markup live here in one place.
import React from 'react'
import { Text } from '../../styles/Components'

// Resolve which wallet to show from the ECE's reported availability. Prefer Apple Pay
// when both are present; returns null until a wallet is reported (availability is
// undefined until the ECE's onReady fires), which hides the wallet entry entirely.
// Both mark SVGs are cropped so the visible pill fills the viewBox, so a shared 22px
// height lines the mark up with the saved-card brand icons.
export const getWalletDisplay = platformPayAvailability => {
  if (platformPayAvailability?.applePay) {
    return { label: 'Apple Pay', mark: { src: '/apple-pay-mark.svg', height: 22 } }
  }
  if (platformPayAvailability?.googlePay) {
    return { label: 'Google Pay', mark: { src: '/google-pay-mark.svg', height: 22 } }
  }
  return null
}

// Renders the wallet mark + label so the wallet row and the collapsed dropdown summary
// line up with saved-card rows. (Raw <img> is fine — the file disables the next/image lint.)
const PlatformPayDetails = ({ label, mark }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <img src={mark.src} alt="" aria-hidden="true" style={{ maxHeight: `${mark.height}px` }} />
    <Text fontSize={18} style={{ marginLeft: '12px' }}>
      {label}
    </Text>
  </div>
)

export default PlatformPayDetails
